<template>
  <modal class="q-modal vlanItem" name="vlan-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="600"
       :minWidth="600"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       height="auto"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">
        {{modalTitle}}
      </div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="form">
              <div class="formRow">
                <span class="title">{{$t('mactable.vlanId')}}</span>
                <span class="forminput" v-if="isAdd">
                  <input name="ID" class="form-control idInput" type="text" :class="{'error': errors.has('ID') || alreadyExist }" v-model="vlanId" v-validate="'required|numeric|max_value:4000|min_value:2'" @keyup="onBlur" @change="onBlur" @keypress="onlyNumber" min="2">
                </span>
                <span class="forminput" v-else>{{vlanId}}</span>
                <div v-show="errors.has('ID') || alreadyExist" class="errorMessage">{{setErrorMessage(errors.first('ID'))}}</div>
              </div>
              <div class="formRow">
                <div class="port-members">{{$t('vlan.vlanCong')}}</div>
                <div class="forminput">
                  <div class="port-select bottom">
                    <table>
                      <tr class="table-header">
                        <td style="width:20%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: 80/(portNumber) + '%' }" v-for="num in portNumber" :key="num">{{num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:20%;">{{$t('vlan.untag')}}</td>
                        <td class="table-body-content" :style="{ width: 80/(portNumber) + '%' }" v-for="num in portNumber" :key="num">
                          <div class="formlabel fontB subitem" @click="onSelection('untag', num)" :title="getTips(num)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked('untag', num)" :disabled="getDisabled(num)" :id="getID('untag', num)"></checkbox>
                          </div>
                        </td>
                      </tr>
                      <tr class="table-body" v-if="(vlanId !== '1') || isAdd">
                        <td class="table-body-content" style="width:20%;">{{$t('vlan.tag')}}</td>
                        <td class="table-body-content" :style="{ width: 80/(portNumber) + '%' }" v-for="num in portNumber" :key="num">
                          <div class="formlabel fontB subitem" @click="onSelection('tag', num)" :title="getTips(num)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked('tag', num)" :disabled="getDisabled(num)"
                              :id="getID('tag', num)"></checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <table>
                      <tr class="table-header">
                        <td style="width:20%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: 80/lagGroupMap.size + '%' }" v-for="num in lagGroupMap.size" :key="num+lagStartNum">{{$t('lag.groupName') + ' ' + num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:20%;">{{$t('vlan.untag')}}</td>
                        <td class="table-body-content" :style="{ width: 80/lagGroupMap.size + '%' }" v-for="num in lagGroupMap.size" :key="num+lagStartNum">
                          <div class="formlabel fontB subitem" @click="onSelection('untag', num + lagStartNum)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked('untag', num + lagStartNum)" :id="getID('untag', num + lagStartNum)"></checkbox>
                          </div>
                        </td>
                      </tr>
                      <tr class="table-body" v-if="(vlanId !== '1') || isAdd">
                        <td class="table-body-content" style="width:20%;">{{$t('vlan.tag')}}</td>
                        <td class="table-body-content" :style="{ width: 80/lagGroupMap.size + '%' }" v-for="num in lagGroupMap.size" :key="num+lagStartNum">
                          <div class="formlabel fontB subitem" @click="onSelection('tag', num + lagStartNum)">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked('tag', num + lagStartNum)" :id="getID('tag', num + lagStartNum)"></checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="formRow errorMessage" v-if="!isValidate">{{errorMessage}}</div>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onSaveClick()" :disabled="!enableBtn" :title="$t('save')">{{$t('save')}}</button>
          <button class="q-button" @click="onClose()" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import checkbox from './module/Checkbox'
export default {
  name: 'VlanItem',
  props: {
    selectVlan: Object,
    tagList: Object,
    tagStatusList: Array,
    modalTitle: String,
    onChange: Function,
    existNum: Array,
    vlanList: Array,
    disabledList: Array,
    lagList: Array
  },
  components: {
    checkbox
  },
  data () {
    return {
      modalname: 'vlan-modal',
      showModal: true,
      vlanId: null,
      isValidate: true,
      unselectList: [],
      selectedList: [],
      originalSelectList: [],
      selectTaggedList: [],
      enableBtn: false,
      removeList: [],
      isDisabled: true,
      alreadyExist: false,
      updateUntag: [],
      tempVlanList: [],
      emptyVlanId: []
    }
  },
  watch: {
    selectVlan: {
      handler (value) {
        this.tempVlanList = JSON.parse(JSON.stringify(this.vlanList))
        if (this.$compareObj(value, {})) {
          this.vlanId = null
          this.originalSelectList = []
        } else {
          this.vlanId = this.selectVlan.key
          this.selectVlan.val.forEach(element => {
            var portNo = Number(element.Port)
            var status = (element.Tagged) ? 'tag' : 'untag'
            this.selectedList[portNo] = status
          })
          this.$log.debug(this.selectedList)
          this.enableBtn = true
          this.originalSelectList = JSON.parse(JSON.stringify(this.selectedList))
        }
        this.setUnselectList()
      }
    }
  },
  methods: {
    ...mapActions(['setVlan', 'delVlan']),
    ...mapMutations([ 'openModal', 'closeModal', 'setModalData' ]),
    async Opened (event) {
      await this.setData()
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let winHeight = document.body.clientHeight
      let height = (this.vlanId !== '1') ? 475 : 370
      let temph = (winHeight > height) ? height : winHeight - 90
      if (modal) {
        modal.style.height = temph + 'px'
        modal.style.top = 'calc(50% - ' + (temph / 2) + 'px'
      }
      this.setData()
    },
    setData: function () {
      if (this.$compareObj(this.selectVlan, {})) {
        this.vlanId = null
        this.originalSelectList = []
      } else {
        this.vlanId = this.selectVlan.key
        this.selectVlan.val.forEach(element => {
          var portNo = Number(element.Port)
          var status = (element.Tagged) ? 'tag' : 'untag'
          if (portNo <= this.portNumber) {
            this.selectedList[portNo] = status
          }
        })
        this.$log.debug(this.selectedList)
        this.enableBtn = true
        this.originalSelectList = JSON.parse(JSON.stringify(this.selectedList))
      }
      this.setUnselectList()
    },
    setUnselectList: function () {
      this.unselectList = []
      for (let idx = 0; idx < this.portNumber; idx++) {
        this.unselectList.push('' + (idx + 1))
      }
    },
    setInitial: function () {
      this.vlanId = null
      this.isValidate = true
      this.enableBtn = false
      this.alreadyExist = false
      this.updateUntag = []
      this.selectedList = []
      this.selectTaggedList = []
    },
    isItemChecked: function (type, item) {
      return (this.selectedList[item] === type)
    },
    onSelection: function (type, item) {
      if (!this.getDisabled(item)) {
        if (this.selectedList[item] && this.selectedList[item] === type) {
          this.selectedList[item] = null
        } else {
          this.selectedList[item] = type
        }
        this.$forceUpdate()
        this.isValidate = true
        this.checkValidation()
      }
    },
    setPortName: function (portNumber) {
      let name = '' + portNumber
      return name
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
      this.setInitial()
    },
    onBlur: function (event) {
      this.checkValidation()
    },
    onCheckValidate: function (oldValue, newValue, port) {
      let me = this
      let originalStatus = this.originalSelectList[port]
      function checkIsOnePort (port, list) {
        let onlyOnePort = true
        for (const key in me.tempVlanList[0]) {
          if (me.tempVlanList[0].hasOwnProperty(key)) {
            const element = me.tempVlanList[0][key]
            if (list[port][0] && list[port][0].key === element.key) {
              if (element.val.length > 1) {
                element.val.forEach((item, idx) => {
                  if (item.Port === '' + port) {
                    onlyOnePort = false
                    element.val.splice(idx, 1)
                  }
                })
                let checkPorts = []
                element.val.forEach(item => {
                  checkPorts.push(item.Port)
                })
                if (!me.checkContainLinkPort(checkPorts)) {
                  me.emptyVlanId.push(element.key)
                  onlyOnePort = true
                }
              } else {
                me.emptyVlanId.push(element.key)
              }
            }
          }
        }
        return onlyOnePort
      }
      function checkIsNoExistGroup (port, list) {
        let onlyOneGroup = false
        if ((!list[port][0] && list[port][1] === 1) || (list[port][0] && list[port][0].key === me.vlanId && !list[port][1])) {
          onlyOneGroup = true
        }
        return onlyOneGroup
      }
      if ((originalStatus !== newValue)) {
        if ((!originalStatus && newValue === 'untag')) { // 新增untag port至該VLAN
          if (this.vlanId === '1' && this.tagStatusList[port - 1] !== 'tag') {
            if (!checkIsOnePort(port, this.tagList)) {
              this.updateUntag[0] = 'remove'
              this.updateUntag.push(port)
            } else {
              this.isValidate = false
            }
          } else if (this.tagStatusList[port - 1] === 'tag') {
          } else {
            if (checkIsOnePort(port, this.tagList)) {
              this.isValidate = false
            } else {
              // edit原group中的untag
              this.updateUntag[0] = 'remove'
              this.updateUntag.push(port)
            }
          }
        } else if (newValue === 'untag') {
          if (originalStatus === 'tag' && this.tagStatusList[port - 1] === 'tag') {
          } else {
            if (checkIsOnePort(port, this.tagList)) {
              this.isValidate = false
            } else {
              this.updateUntag[0] = 'remove'
              this.updateUntag.push(port)
            }
          }
        } else if ((!originalStatus) && (newValue === null)) {
        } else if (newValue === null) {
          if (checkIsNoExistGroup(port, this.tagList)) {
            this.isValidate = false
          }
        }
      }
    },
    setUntag: function () {
      if (this.updateUntag.length > 0) {
        if (this.updateUntag[0] === 'remove') {
          this.updateUntag.forEach((element, index) => {
            if (index > 0) {
              var data = this.tagList[element][0]
              data.val.forEach((item, idx) => {
                if (item.Port === '' + element) {
                  this.tagList[element][0].val.splice(idx, 1)
                }
              })
              this.setVlan({data: [data], action: 'edit'})
            }
          })
        }
      }
    },
    onSaveClick: async function () {
      let val = []
      let checkPorts = []
      this.updateUntag = []
      this.emptyVlanId = []
      this.isValidate = true
      this.selectedList.forEach((element, index) => {
        if (element) {
          checkPorts.push(index.toString())
        }
      })
      if (this.checkContainLinkPort(checkPorts)) {
        this.selectedList.forEach((element, index) => {
          let tagged = null
          element === 'tag' ? tagged = true : tagged = false
          this.onCheckValidate(this.tagStatusList[index - 1], element, index)
          if (element) {
            val.push({
              Port: index.toString(),
              Tagged: tagged
            })
          }
        })
      } else {
        this.emptyVlanId.push(this.vlanId)
        this.isValidate = false
      }
      if (this.isValidate) {
        await this.setUntag()
        var data = [{
          key: this.vlanId,
          val: val
        }]
        if (this.isAdd) {
          this.setVlan({data: data, action: 'add'})
            .then((result) => {
              this.onChange()
              this.onClose()
            })
            .catch((error) => {
              this.$log.error(error)
              if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
                this.$parent.onLogout()
              } else {
                this.$log.error(error)
              }
            })
        } else {
          this.setVlan({data: data, action: 'edit'})
            .then((result) => {
              this.onChange()
              this.onClose()
            })
            .catch((error) => {
              this.$log.error(error)
              if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
                this.$parent.onLogout()
              } else {
                this.$log.error(error)
              }
            })
        }
      } else {
        this.tempVlanList = JSON.parse(JSON.stringify(this.vlanList))
      }
    },
    checkCellValidation: function () {
      let result = false
      this.selectedList.forEach(element => {
        if (element) {
          result = true
        }
      })
      this.enableBtn = result
    },
    checkValidation: function (fieldName) {
      let me = this
      if (this.isAdd && this.existNum.indexOf(this.vlanId) > -1) {
        this.enableBtn = false
        this.alreadyExist = true
      } else {
        this.alreadyExist = false
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.checkCellValidation()
          } else {
            this.enableBtn = result
          }
        }).catch(() => {
          me.enableBtn = false
        })
      }
    },
    checkContainLinkPort: function (list) {
      let result = false
      let inUseLagPorts = []
      this.lagList.forEach(item => {
        if (item.val.PortMembers.length > 0) {
          let port = Number(item.key) + this.lagStartNum
          inUseLagPorts.push(port.toString())
        }
      })
      list.forEach(item => {
        if (item <= this.portNumber) {
          result = true
        } else if (inUseLagPorts.includes(item)) {
          result = true
        }
      })
      return result
    },
    setErrorMessage: function (data) {
      let message = this.$t('vlan.vlanId')
      if (this.alreadyExist) {
        message = this.$t('errorMessage.vlanNumDuplicate')
      } else if (data && data.indexOf('required') > -1) {
        message = this.$t('errorMessage.isReguired')
      } else {
        message = this.$t('errorMessage.vlanIdRange')
      }
      return message
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let isFunctionKey = false
      switch (keyCode) {
        case 8:
          isFunctionKey = true
          break
      }
      if ((keyCode < 48 || keyCode > 57) && !isFunctionKey) { // 46 is dot
        $event.preventDefault()
      }
    },
    getDisabled: function (port) {
      if (this.disabledList.indexOf(port) > -1) {
        return true
      } else {
        return false
      }
    },
    getTips (port) {
      let title = ''
      if (this.disabledList.indexOf(port) > -1) {
        title = this.$t('lag.alreadyJoin')
      }
      return title
    },
    getID: function (type, number) {
      return 'checkbox-' + type + '-' + number
    }
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum,
      lagStartNum: state => state.module.lagStartNum,
      lagGroupMap: state => state.module.lagGroupMap
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    isAdd () {
      if (this.modalTitle === this.$t('vlan.addVlan')) {
        return true
      } else {
        return false
      }
    },
    errorMessage () {
      let result = ''
      let noRepeatList = [...new Set(this.emptyVlanId)]
      let idList = JSON.parse(JSON.stringify(noRepeatList))
      if (idList.length > 0) {
        result = this.$t('vlan.empty', {0: idList.sort((a, b) => a - b).join(', ')})
      } else {
        result = this.$t('vlan.atleastOne')
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

@import '../assets/scss/modal.scss';

.vlanItem {
  .modal-container {
    .formRow {
      .idInput {
        width: 100px;
      }
      .forminput {
        margin: 0px 10px;
        .port-select {
          margin-top: 10px;
          >table {
            width: 100%;
            text-align: center;
            tr {
              border-bottom: 1px solid #E5E5E5;
            }
            .table-header {
              background: #E5E5E5;
              height: 40px;
              text-align: center;
            }
            .table-body {
              height: 38px;
            }
          }
        }
      }
      .errorMessage {
        padding-left: 72px;
      }
      .port-members {
        margin: 10px 0px;
      }
    }
  }
  .hello {
    background: blue;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/VlanItem.vue